import { QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { LangProvider } from '@/lib/LangProvider'
import { queryClient } from '@/lib/query-client'

/**
 * Every app-wide context provider, in one place. New ones (theme, i18n,
 * auth session) are added here rather than threaded through main.tsx.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <LangProvider>{children}</LangProvider>
    </QueryClientProvider>
  )
}
